// El backend resuelve el período del colegio; las operaciones posteriores lo conservan.
export const exigirPeriodoEscolar = (periodo) => {
  if (typeof periodo !== 'string' || !/^\d{4}-\d{4}$/.test(periodo)) {
    throw new Error('No se pudo determinar el período escolar. Recarga los horarios.');
  }
  return periodo;
};

export const parametrosHorarios = (docenteID, colegioID, anioEscolar) => {
  const params = new URLSearchParams({ docenteID, colegioID });
  if (anioEscolar) params.set('anioEscolar', exigirPeriodoEscolar(anioEscolar));
  return params;
};

export const periodoDeHorarios = (respuesta) => exigirPeriodoEscolar(
  respuesta.anioEscolar || respuesta.horarios?.[0]?.AnioEscolar
);

export const mensajePeriodoDocente = (periodoSesion, periodoHorario) => {
  if (!/^\d{4}-\d{4}$/.test(periodoSesion || '') || !/^\d{4}-\d{4}$/.test(periodoHorario || '') ||
      periodoSesion === periodoHorario) return '';
  return `Tu sesión corresponde al período ${periodoSesion}, pero los horarios son del período ${periodoHorario}. ` +
    'Vuelve a ingresar con tu correo más reciente. Si tu carnet nuevo aún no tiene correo, usa el del carnet anterior.';
};
